import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0974a388"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "resulttable" }
const _hoisted_2 = { class: "flow flow--5" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "downloadLink" }, "Download link", -1))
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "downloadModal_footer" }

import { ref, computed } from 'vue';
import { ComplexDownload, SimpleDownload, TranslatedDownload } from '@/types';
import { useI18n } from 'vue-i18n';
import ResultTableColumn from '../molecules/ResultTableColumn.vue';
import ResultTableHead from '../molecules/ResultTableHead.vue';
import constants from '../../config/constants';
import configHelper from '../../helpers/configHelper';
import { useFetch } from '../../hooks';
import Modal from '../molecules/Modal.vue';
import { useNotifications } from '../../hooks/useNotifications';


export default /*#__PURE__*/_defineComponent({
  props: {
    items: null,
    year: null,
    id: null
  },
  setup(__props: any) {

const props = __props as {
  items: (ComplexDownload | SimpleDownload)[];
  year: string;
  id: string;
}

/* eslint-disable no-underscore-dangle */
const { fetchApi, errorMessage } = useFetch(configHelper.PDA_API);
const { showNotification } = useNotifications();

const sortKey = ref<keyof (ComplexDownload | SimpleDownload)>('downloadTyp');
const sortDirection = ref<boolean>(true);
const showModal = ref<boolean>(false);
const dowloadLink = ref<string>();

const i18n = useI18n();

const translatedItems = computed(() => {
  const output: TranslatedDownload[] = [];

  props.items.forEach((item) => {
    const fullDownloadType = constants.downloadTypes[item.downloadTyp];

    const translatedDownloadType = fullDownloadType
      ? i18n.t(fullDownloadType.platzhalter)
      : i18n.t('unkownDownloadType', { type: item.downloadTyp });

    const translatedItem: TranslatedDownload = {
      sort: item.sort,
      _id: item._id,
      file: item.file,
      downloadTyp: translatedDownloadType,
      ...('language' in item ? { language: i18n.t(`lang_${item.language}`) } : {}),
      ...('region' in item
        ? {
            region:
              constants.technicalRegionsObject[
                item.region as unknown as keyof typeof constants.technicalRegionsObject
              ],
          }
        : {}),
    };

    output.push(translatedItem);
  });

  return output;
});

const sortedItems = computed(() => {
  const sorted = [...translatedItems.value].sort((a, b) => {
    if (a[sortKey.value] > b[sortKey.value]) return sortDirection.value ? 1 : -1;
    if (a[sortKey.value] < b[sortKey.value]) return sortDirection.value ? -1 : 1;
    return 0;
  });

  return sorted;
});

const sortItems = (key: keyof (ComplexDownload | SimpleDownload), direction: boolean) => {
  sortKey.value = key;
  sortDirection.value = direction;
};

const createSharableLink = async (item: TranslatedDownload) => {
  try {
    const result = await fetchApi<{ token: string; url: string }>(
      `/articles/${props.year}/${props.id}/${item._id}/token`,
      {
        method: 'POST',
        useCredentials: true,
      },
    );
    dowloadLink.value = result.url;
    showModal.value = true;
  } catch (error) {
    console.log(error);
    showNotification(i18n.t('genericError') + i18n.t('createSharableLinkError'), 'error');
  }
};

const copyToClipboard = () => {
  if (dowloadLink.value)
    navigator.clipboard.writeText(dowloadLink.value).then(() => {
      showNotification(i18n.t('copySuccess'), 'success');
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("thead", null, [
        _createVNode(ResultTableHead, {
          keys: ['downloadTyp', 'language', 'region'],
          sort: sortItems,
          "current-key": sortKey.value
        }, null, 8, ["current-key"])
      ]),
      _createElementVNode("tbody", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortedItems), (item) => {
          return (_openBlock(), _createBlock(ResultTableColumn, {
            id: __props.id,
            key: item._id,
            item: item,
            year: __props.year,
            onGenerateShareableLink: () => createSharableLink(item)
          }, null, 8, ["id", "item", "year", "onGenerateShareableLink"]))
        }), 128))
      ])
    ]),
    _createVNode(Modal, {
      show: showModal.value,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (showModal.value = false))
    }, {
      header: _withCtx(() => [
        _createElementVNode("h4", null, _toDisplayString(_ctx.$t('successfulDownloadLinkHeader')), 1)
      ]),
      body: _withCtx(() => [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('sharableLinkHint')), 1),
        _createElementVNode("div", null, [
          _hoisted_3,
          _createElementVNode("input", {
            id: "downloadLink",
            readonly: "",
            type: "text",
            value: dowloadLink.value,
            onClick: _cache[0] || (_cache[0] = (e) => {
        (e.target as HTMLInputElement).select()
      }
      )
          }, null, 8, _hoisted_4)
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "button button--cta-primary button--medium",
            onClick: copyToClipboard
          }, _toDisplayString(_ctx.$t('copySharableLink')), 1),
          _createElementVNode("button", {
            class: "button button--primary button--medium m-l-4",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (showModal.value = false))
          }, _toDisplayString(_ctx.$t('closeModal')), 1)
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})